import { BaseService } from 'hungry-core2'

import actions from '@actions'

export default class EditPDFModal extends BaseService {
  close = () => {
    this.dispatch(actions.toggleEditPDFModal(false))
  }

  show = () => {
    this.dispatch(actions.toggleEditPDFModal(true))
  }
}
